<template>
  <div>
    <div v-if="isLink">
      <a :href="'/books/' + bookInfo.id_book+ '/'" :class="{'is-first': isFirst}" class="card card-list__card sp-on">
        <div class="card__inner card__inner--arrow">
          <div class="card__photo">
            <img :src="bookInfo.img_url" alt="">
          </div>
          <section class="card__body card-body">
            <h4 class="card-body__ttl">{{ bookInfo.name_book }}</h4>
            <p class="card-body__author">著者：<span>{{ bookInfo.author }}</span></p>
            <!-- <app-star :rate="bookInfo.rating"></app-star> -->
            <p class="card-body__coupon-price" v-if="isCouponShow">割引価格： <span>￥{{bookInfo.discounted_price_jp}}</span></p>

            <div v-if="discountPrice <= 0">
              <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
              <p class="card-body__book-price">紙の本の価格： <span>￥{{ bookInfo.price_jp_book }}</span></p>
              <p class="card-body__discount">￥{{ discountPrice }}の割引({{ discountRate | percentFormatInt }})</p>
            </div>
            <div v-else-if="bookInfo.price_jp_book < bookInfo.price_jp">
              <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
            </div>
            <div v-else>
              <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
              <p class="card-body__book-price">紙の本の価格： ￥{{ bookInfo.price_jp_book }}</p>
            </div>
          </section>
        </div>
      </a>
      <div class="pc-card-wrapper pc-on">
        <a :href="'/books/' + bookInfo.id_book+ '/'" class="pc-card"  :class="{'is-first': isFirst}" >
          <div class="pc-card__photo">
            <img :src="bookInfo.img_url" alt="">
          </div>
          <section class="pc-card__body pc-card-body">
            <h4 class="pc-card-body__ttl">{{ bookInfo.name_book }}</h4>
            <div class="pc-card-info">
              <section class="pc-card-info__block">
                <p class="pc-card-body__author">著者：<span>{{ bookInfo.author }}</span></p>
                <!-- <app-star :rate="bookInfo.rating"></app-star> -->
              </section>
              <section class="pc-card-info__block">
                <p class="card-body__coupon-price" v-if="isCouponShow">割引価格： <span>￥{{bookInfo.discounted_price_jp}}</span></p>

                <div v-if="discountPrice <= 0">
                  <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
                  <p class="pc-card-body__book-price">紙の本の価格： ￥{{ bookInfo.price_jp_book }}</p>
                </div>
                <div v-else-if="bookInfo.price_jp_book < bookInfo.price_jp">
                  <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
                </div>
                <div v-else>
                  <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
                  <p class="pc-card-body__book-price">紙の本の価格： <span>￥{{ bookInfo.price_jp_book }}</span></p>
                  <p class="pc-card-body__discount">￥{{ discountPrice }}の割引({{ discountRate | percentFormatInt }})</p>
                </div>
              </section>
            </div>
          </section>
        </a>
        <div class="pc-card-wrapper__btn">
          <a href="javascript:void(0);" @click="clickPurchase()" class="pc-card__purcahse btn-square btn-square--short" v-if="!hasPurchased" :class="{isActive: (isCreditAvailabel && !hasPurchased)}">購入する</a>
          <span v-else class="pc-card__purcahse btn-square btn-square--short btn-square--disabled" :class="{isActive: (isCreditAvailabel && !hasPurchased)}">購入済み</span>
          <p v-if="isCreditAvailabel && !hasPurchased" class="pc-card__purcahse-alert">ボタンを押すと注文が確定されます。</p>
        </div>
      </div>
    </div>

    <div v-else>
      <router-link :to="'/books/' + bookInfo.id_book + '/'" :class="{'is-first': isFirst}" class="card card-list__card sp-on">
        <div class="card__inner card__inner--arrow">
          <div class="card__photo">
            <div class="ranking-label" v-if="rankingNumber">
              <span class="ranking-label__number">{{rankingNumber}}</span>
              <img src="/static/img/ranking_gold.png" alt="" class="ranking-label__bg" v-if="rankingNumber === 1">
              <img src="/static/img/ranking_silver.png" alt="" class="ranking-label__bg" v-else-if="rankingNumber === 2">
              <img src="/static/img/ranking_bronz.png" alt="" class="ranking-label__bg" v-else-if="rankingNumber === 3">
              <img src="/static/img/ranking_red.png" alt="" class="ranking-label__bg" v-else>
            </div>
            <img :src="bookInfo.img_url" alt="">
          </div>
          <section class="card__body card-body">
            <h4 class="card-body__ttl">{{ bookInfo.name_book }}</h4>
            <p class="card-body__author">著者：<span>{{ bookInfo.author }}</span></p>
            <!-- <app-star :rate="bookInfo.rating"></app-star> -->
            <p class="card-body__coupon-price" v-if="isCouponShow">割引価格： <span>￥{{bookInfo.discounted_price_jp}}</span></p>

            <div v-if="discountPrice <= 0">
              <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
              <p class="card-body__book-price">紙の本の価格： ￥{{ bookInfo.price_jp_book }}</p>
            </div>
            <div v-else-if="bookInfo.price_jp_book < bookInfo.price_jp">
              <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
            </div>
            <div v-else>
              <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
              <p class="card-body__book-price">紙の本の価格： <span>￥{{ bookInfo.price_jp_book }}</span></p>
              <p class="card-body__discount">￥{{ discountPrice }}の割引({{ discountRate | percentFormatInt }})</p>
            </div>
          </section>
        </div>
      </router-link>
      <div class="pc-card-wrapper pc-on">
        <router-link :to="'/books/' + bookInfo.id_book + '/'" class="pc-card" :class="{'is-first': isFirst}">
          <div class="pc-card__photo">
            <div class="ranking-label" v-if="rankingNumber">
              <span class="ranking-label__number">{{rankingNumber}}</span>
              <img src="/static/img/ranking_gold.png" alt="" class="ranking-label__bg" v-if="rankingNumber === 1">
              <img src="/static/img/ranking_silver.png" alt="" class="ranking-label__bg" v-else-if="rankingNumber === 2">
              <img src="/static/img/ranking_bronz.png" alt="" class="ranking-label__bg" v-else-if="rankingNumber === 3">
              <img src="/static/img/ranking_red.png" alt="" class="ranking-label__bg" v-else>
            </div>
            <img :src="bookInfo.img_url" alt="">
          </div>
          <section class="pc-card__body pc-card-body">
            <h4 class="pc-card-body__ttl">{{ bookInfo.name_book }}</h4>
            <div class="pc-card-info">
              <section class="pc-card-info__block">
                <p class="pc-card-body__author">著者：<span>{{ bookInfo.author }}</span></p>
                <!-- <app-star :rate="bookInfo.rating"></app-star> -->
              </section>
              <section class="pc-card-info__block">
                <p class="card-body__coupon-price" v-if="isCouponShow">割引価格： <span>￥{{bookInfo.discounted_price_jp}}</span></p>

                <div v-if="discountPrice <= 0">
                  <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
                  <p class="pc-card-body__book-price">紙の本の価格： ￥{{ bookInfo.price_jp_book }}</p>
                </div>
                <div v-else-if="bookInfo.price_jp_book < bookInfo.price_jp">
                  <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
                </div>
                <div v-else>
                  <p class="card-body__abc-price" :class="{canceled: isCouponShow}">abceed版価格： <span>￥{{bookInfo.price_jp}}</span></p>
                  <p class="pc-card-body__book-price">紙の本の価格： <span>￥{{ bookInfo.price_jp_book }}</span></p>
                  <p class="pc-card-body__discount">￥{{ discountPrice }}の割引({{ discountRate | percentFormatInt }})</p>
                </div>
              </section>
            </div>
          </section>
        </router-link>
        <div class="pc-card-wrapper__btn">
          <a href="javascript:void(0);" @click="clickPurchase()" class="pc-card__purcahse btn-square btn-square--short" v-if="!hasPurchased" :class="{isActive: (isCreditAvailabel && !hasPurchased)}">購入する</a>
          <span v-else class="pc-card__purcahse btn-square btn-square--short btn-square--disabled" :class="{isActive: (isCreditAvailabel && !hasPurchased)}">購入済み</span>
          <p v-if="isCreditAvailabel && !hasPurchased" class="pc-card__purcahse-alert">ボタンを押すと注文が確定されます。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Star from '../smallParts/Star.vue';

  export default {
    props: ["bookInfo", "isCreditAvailabel", "isLink", "isFirst", "rankingNumber"],
    components: {
      appStar: Star
    },
    data() {
      return {
        starRateFloor: '',
        isStarHalf: false,
        couponList: [],
        isCouponShow: false,
        hasPurchased: false,
      }
    },
    created() {
      if (this.bookInfo.user_coupon_list) {
        this.couponList = this.bookInfo.user_coupon_list;
      }
      if (this.bookInfo.price_jp > this.bookInfo.discounted_price_jp) {
        this.isCouponShow = true;
      }
      this.hasPurchased = this.bookInfo.has_purchased;
    },
    methods: {
      clickPurchase() {
        if (this.isCreditAvailabel) {
          //クレカ購入済みの場合はその場で決済させる
          this.$store.dispatch("showLightBox", "loading");
          this.$store.dispatch("purchaseByToken", {
            ignore_token: true,
            id_book: this.bookInfo.id_book
          }).then(data => {
            if (data.result) {
              //購入成功
              this.hasPurchased = true;
              this.$store.dispatch("showLightBox", "bookDetailResult");
            } else {
              this.$store.dispatch("hideLightBox");
              alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
            }
          }).catch(() => {
            this.$store.dispatch("hideLightBox");
            alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
          });
        } else {
          //購入方法選択画面へ
          this.$router.push({name: 'paymentWay', params: { id: this.bookInfo.id_book }});
        }
      },
    },
    computed: {
      discountPrice() {
        if (this.bookInfo.price_jp_book < this.bookInfo.price_jp) {
          return this.bookInfo.price_jp / 0.9 - this.bookInfo.discounted_price_jp;
        } else {
          return this.bookInfo.price_jp_book - this.bookInfo.discounted_price_jp;
        }
      },
      discountRate() {
        if (this.bookInfo.price_jp_book < this.bookInfo.price_jp) {
          return this.discountPrice / (this.bookInfo.price_jp / 0.9);
        } else {
          return this.discountPrice / this.bookInfo.price_jp_book;
        }
      },
    }
  }
</script>

<style>
  .review-stars__full {
    margin: 0 2px 0 0;
  }
  .star-half {
    margin-left: -2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/books/Book.vue